import { Props } from './Layout'
import { useRandomArcadeMachinesQuery } from './query.generated'
import { useRouter } from 'next/router'
import { PagePaths } from '@/src/utils/PagePaths'
import { useState } from 'react'
import { useGameInfo } from '@/src/stores/Games/useGames'
import { S3URLService } from '@/src/services/S3URLService'

export type Params = {
  gameId: string
}

export const useProps = ({ gameId }: Params): Props => {
  const { data, loading } = useRandomArcadeMachinesQuery({ variables: { game: gameId } })
  const { games } = useGameInfo()
  const router = useRouter()

  const [visibleGameSelect, setGameSelect] = useState(false)

  return {
    ams:
      data?.listRandomArcadeMachines.arcadeMachines.map((am) => ({
        id: am.id,
        energy: am.energy,
        maxEnergy: am.maxEnergy,
        extractedEnergy: am.extractedEnergy,
        amImageUrl: am.metadata.withoutAccImageUrl ?? '',
        gameImageUrl: S3URLService.getGameThumbnailImageURL(gameId) ?? '',
        megaSparkUpcoming: !!am.megaSparkUpcoming,
        inOperation: !!am.playing,
        feverSparkRemain: am.feverSparkRemain ?? null,
      })) ?? [],
    games: games.map((g) => ({ id: g.id, name: g.name })),
    selectedGame: gameId,
    selectedGameTitle: games?.find((g) => g.id === gameId)?.name ?? '',
    loading,
    onClickBack: () => router.push(PagePaths.top()),
    visibleGameSelect,
    onClickGameSelect: () => setGameSelect(true),
    onClickGameSelectClose: () => setGameSelect(false),
    onClickGameSelectAccept: (gameId) => {
      setGameSelect(false)
      router.push(PagePaths.arcadeMachineSearch(gameId))
    },
  }
}
